import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Modalbox = ({ Images, selectedImageIndex, handleCloseModal }) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {/* <button onClick={handleCloseModal} style={{ position: "absolute", top: "10px", right: "10px" }}>
        Close
      </button> */}
      <Carousel
        showThumbs={false}
        selectedItem={selectedImageIndex}
        infiniteLoop={false}
        showStatus={false}
        autoPlay={false}
        showArrows={true}
      >
        {Images.map((image, index) => (
          <div key={index}>
            <img src={image.url} alt={`img-${index}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Modalbox;